/* tslint:disable */
import {
  Account,
  App,
  Apptype,
  Tenant,
  Entity
} from '../index';

declare var Object: any;
export interface PaastenantInterface {
  name: string;
  status: string;
  ownerId: any;
  lastupdatedby?: string;
  createdby?: string;
  id?: any;
  createdAt: Date;
  updatedAt: Date;
  owner?: Account;
  apps?: App[];
  apptypes?: Apptype[];
  tenants?: Tenant[];
  entities?: Entity[];
}

export class Paastenant implements PaastenantInterface {
  name: string;
  status: string;
  ownerId: any;
  lastupdatedby: string;
  createdby: string;
  id: any;
  createdAt: Date;
  updatedAt: Date;
  owner: Account;
  apps: App[];
  apptypes: Apptype[];
  tenants: Tenant[];
  entities: Entity[];
  constructor(data?: PaastenantInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Paastenant`.
   */
  public static getModelName() {
    return "Paastenant";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Paastenant for dynamic purposes.
  **/
  public static factory(data: PaastenantInterface): Paastenant{
    return new Paastenant(data);
  }  
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Paastenant',
      plural: 'paastenants',
      properties: {
        name: {
          name: 'name',
          type: 'string'
        },
        status: {
          name: 'status',
          type: 'string'
        },
        ownerId: {
          name: 'ownerId',
          type: 'any'
        },
        lastupdatedby: {
          name: 'lastupdatedby',
          type: 'string',
          default: 'system'
        },
        createdby: {
          name: 'createdby',
          type: 'string',
          default: 'system'
        },
        id: {
          name: 'id',
          type: 'any'
        },
        createdAt: {
          name: 'createdAt',
          type: 'Date'
        },
        updatedAt: {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        owner: {
          name: 'owner',
          type: 'Account',
          model: 'Account'
        },
        apps: {
          name: 'apps',
          type: 'App[]',
          model: 'App'
        },
        apptypes: {
          name: 'apptypes',
          type: 'Apptype[]',
          model: 'Apptype'
        },
        tenants: {
          name: 'tenants',
          type: 'Tenant[]',
          model: 'Tenant'
        },
        entities: {
          name: 'entities',
          type: 'Entity[]',
          model: 'Entity'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/Paastenant.ts